<template>
    <img :src="btn.src" style="width:100%" />
</template>

<script>

export default {
    props: ['btn']
}    
</script>